export default __webpack_public_path__ + "static/media/about-us-hero.b38d7880.jpg";